import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshaniwarwadatourcab() {



  const cardData = {
"keyword": "Pune to Shaniwar Wada Tour Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Shaniwar Wada Tour Cab for travelers who want a smooth, convenient, and well-planned city sightseeing experience focused on Pune’s most iconic historical landmark. Whether you are a tourist exploring Pune for the first time, a history enthusiast, a family on a leisure trip, or a group planning a cultural outing, our cab service ensures a stress-free journey with complete comfort. With experienced drivers who are well-versed with Pune city routes and traffic conditions, clean air-conditioned vehicles maintained for short-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from any part of Pune to Shaniwar Wada. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible half-day and full-day city tour options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and enriching historical travel experience.",

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description":
      "Shaniwar Wada is one of Pune’s most famous historical monuments built in 1732 by the Peshwas of the Maratha Empire. Known for its grand architecture, massive gates, and rich historical stories, it was once the seat of power in Maharashtra. The fort palace is especially popular for its light and sound show, which narrates the history of the Maratha dynasty in a dramatic and engaging way."
  },
  {
    "title": "Lal Mahal",
    "description":
      "Lal Mahal is a significant historical landmark associated with Chhatrapati Shivaji Maharaj’s childhood. Reconstructed near Shaniwar Wada, it showcases important events from Maratha history and features paintings, artifacts, and exhibits that reflect Pune’s royal heritage."
  },
  {
    "title": "Shaniwar Wada Light & Sound Show Area",
    "description":
      "The evening light and sound show at Shaniwar Wada brings the fort’s history alive through narration, lights, and music. It is one of the most popular attractions for tourists taking Pune heritage and Shaniwar Wada tour cabs."
  },
  {
    "title": "Kasba Peth Heritage Zone",
    "description":
      "Kasba Peth is one of the oldest localities in Pune, known for its traditional culture, narrow lanes, and historic temples. It reflects the old Pune lifestyle and is often explored along with Shaniwar Wada tours."
  },
  {
    "title": "Tulshibaug Market",
    "description":
      "Tulshibaug is a famous traditional shopping area near Shaniwar Wada known for jewelry, household items, and local street shopping. It offers a vibrant cultural experience for visitors."
  },
  {
    "title": "Dagadusheth Halwai Ganpati Temple",
    "description":
      "Dagadusheth Halwai Ganpati Temple is one of Pune’s most revered temples dedicated to Lord Ganesha. It is a must-visit spiritual stop located close to Shaniwar Wada during city tours."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description":
      "Raja Dinkar Kelkar Museum showcases a vast collection of Indian artifacts, musical instruments, sculptures, and cultural items, offering deep insight into India’s heritage and traditions."
  },
  {
    "title": "Vishrambaug Wada",
    "description":
      "Vishrambaug Wada is a beautifully preserved Peshwa-era mansion known for its wooden architecture and historical importance in Pune’s royal history."
  },
  {
    "title": "Sarasbaug Ganpati Temple",
    "description":
      "Sarasbaug Ganpati Temple is located inside a peaceful garden and is a popular spiritual and leisure destination for families visiting Pune city."
  },
  {
    "title": "Pune Heritage City Route",
    "description":
      "The Pune to Shaniwar Wada tour route covers major historical, cultural, and spiritual landmarks within the city, offering a complete heritage experience through Pune’s royal Maratha history and vibrant urban culture."
  }
],



services: [
  {
    name: "Pune Shaniwar Wada Tour Cab",
    description: "Pune Shaniwar Wada tour cab service provides reliable transportation for travelers exploring Pune’s famous historical attractions and heritage landmarks. Comfortable vehicles with experienced drivers ensure smooth city travel for families, tourists, history enthusiasts, and local travelers. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different sightseeing requirements. Flexible booking options allow convenient heritage tour cab reservations."
  },
  {
    name: "Pune City Heritage Cab",
    description: "Pune city heritage cab service offers dependable transportation for sightseeing tours across Pune’s cultural and historical attractions with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth city travel suitable for tourism, heritage visits, shopping, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the city tour. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient heritage cab reservations."
  },
  {
    name: "Shaniwar Wada Sightseeing Taxi",
    description: "Shaniwar Wada sightseeing taxi service provides comfortable transportation for passengers visiting historical monuments, forts, museums, and famous landmarks in Pune. Vehicles ensure reliable local travel with experienced chauffeurs offering safe and smooth city journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day sightseeing and tourism requirements. Flexible booking options allow convenient sightseeing taxi reservations."
  },
  {
    name: "Pune Historical Tour Cab",
    description: "Pune historical tour cab service offers reliable transportation with comfortable vehicles and professional drivers for exploring Pune’s historical sites and heritage attractions. Vehicles provide smooth city travel suitable for tourism, sightseeing, educational trips, and family outings. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy historical tour cab reservations."
  },
  {
    name: "Pune Fort Tour Shaniwar Wada Cab",
    description: "Pune fort tour Shaniwar Wada cab service provides dependable transportation solutions for passengers traveling across Pune’s famous forts and historical monuments. Vehicles are suitable for city travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for heritage tourism, cultural visits, and sightseeing tours. Flexible booking options allow convenient fort tour cab reservations."
  },
  {
    name: "Pune Local Sightseeing Taxi",
    description: "Pune local sightseeing taxi service provides transparent and reliable transportation for travelers visiting Pune’s popular tourist attractions and heritage landmarks. Travelers can enjoy comfortable journeys with experienced drivers familiar with local sightseeing routes and destinations. Comfortable vehicles ensure smooth city travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sightseeing taxi reservations."
  },
  {
    name: "Best Pune Tour Cab Shaniwar Wada",
    description: "Best Pune tour cab Shaniwar Wada service provides economical and comfortable transportation for travelers planning sightseeing tours across Pune city. Comfortable vehicles ensure smooth city travel suitable for tourism, shopping, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient tour cab reservations."
  },
  {
    name: "Cheap Pune Sightseeing Cab",
    description: "Cheap Pune sightseeing cab service offers convenient transportation for passengers planning affordable sightseeing and heritage trips across Pune city. Comfortable vehicles provide smooth local travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for local sightseeing, tourism visits, and city tours. Flexible booking options allow economical sightseeing cab reservations."
  },
  {
    name: "SUV Pune Heritage Tour Cab",
    description: "SUV Pune heritage tour cab service provides spacious transportation for families and groups traveling across Pune for heritage sightseeing and tourism. SUV vehicles offer comfortable seating, luggage capacity, and smooth city performance suitable for family outings and cultural tours. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV heritage cab reservations."
  },
  {
    name: "Innova Pune City Tour Cab",
    description: "Innova Pune city tour cab service provides premium SUV transportation for passengers seeking comfortable and reliable city sightseeing travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova city tour cab reservations."
  },
  {
    name: "Sedan Pune Tour Taxi",
    description: "Sedan Pune tour taxi service offers economical and comfortable transportation for solo travelers, couples, and small families exploring Pune city. Sedan vehicles provide smooth city travel with comfortable seating and luggage space suitable for local sightseeing journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan tour taxi reservations."
  },
  {
    name: "Pune Guided Tour Cab",
    description: "Pune guided tour cab service offers dependable transportation for passengers exploring Pune’s heritage landmarks, museums, temples, and tourist attractions. Comfortable vehicles ensure smooth city travel suitable for tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient guided tour cab reservations."
  },
  {
    name: "Pune Monument Tour Taxi",
    description: "Pune monument tour taxi service provides reliable transportation for travelers planning sightseeing tours to famous monuments and historical attractions across Pune. Comfortable vehicles ensure smooth and safe city travel suitable for tourists, students, families, and cultural travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient monument tour taxi reservations."
  },
  {
    name: "Pune Cultural Tour Cab",
    description: "Pune cultural tour cab service offers comfortable transportation for passengers visiting cultural centers, museums, historical places, and traditional attractions across Pune city. Vehicles ensure reliable local travel with experienced chauffeurs offering safe and smooth city journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for educational trips, cultural tourism, and sightseeing requirements. Flexible booking options allow convenient cultural tour cab reservations."
  },
  {
    name: "Pune Historical Travel Cab",
    description: "Pune historical travel cab service provides complete transportation solutions for travelers planning historical tours and heritage sightseeing across Pune. Comfortable vehicles ensure smooth city travel suitable for tourism, educational tours, shopping trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient historical travel cab reservations."
  }
],

tableData: [
  ["Pune Shaniwar Wada Tour Cab", "Pune City Heritage Cab"],
  ["Shaniwar Wada Sightseeing Taxi", "Pune Historical Tour Cab"],
  ["Pune Fort Tour Shaniwar Wada Cab", "Pune Local Sightseeing Taxi"],
  ["Best Pune Tour Cab Shaniwar Wada", "Cheap Pune Sightseeing Cab"],
  ["SUV Pune Heritage Tour Cab", "Innova Pune City Tour Cab"],
  ["Sedan Pune Tour Taxi", "Pune Guided Tour Cab"],
  ["Pune Monument Tour Taxi", "Pune Cultural Tour Cab"],
  ["Pune Historical Travel Cab", "Pune Shaniwar Wada Tour Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Shaniwar Wada Tour Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Shaniwar Wada Tour cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and enjoyable heritage sightseeing travel."
      },
      {
        WhyChooseheading: "Affordable Shaniwar Wada Tour Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Shaniwar Wada Tour cab pricing with transparent fare details and no hidden charges. Customers receive complete tour package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Shaniwar Wada Tour Cab Availability",
        WhyChoosedescription: "Our Pune to Shaniwar Wada Tour cab service operates 24 hours a day for heritage sightseeing, family outings, tourist visits, historical tours, and customized Pune city travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during Pune sightseeing tours."
      },
      {
        WhyChooseheading: "Customized Pune Heritage Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Shaniwar Wada tours, Aga Khan Palace visits, Dagdusheth Ganpati Darshan, Saras Baug sightseeing, and customized Pune city travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, students, and group sightseeing tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Pune Sightseeing Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune heritage locations and city routes, ensuring smooth travel and timely visits to historical attractions like Shaniwar Wada."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Shaniwar Wada Tour cab service?", answer: "Pune to Shaniwar Wada Tour cab service provides comfortable taxi transportation for visiting Shaniwar Wada and nearby tourist attractions in Pune." },
    { question: "Is Pune to Shaniwar Wada Tour cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Shaniwar Wada Tour cab service." },
    { question: "Which vehicles are available for Shaniwar Wada tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized Pune heritage tour packages?", answer: "Yes, customers can book customized Pune sightseeing and heritage travel packages according to their requirements." },
    { question: "Which tourist places are covered in the Shaniwar Wada tour?", answer: "Shivai Travels covers Shaniwar Wada, Dagdusheth Ganpati, Aga Khan Palace, Saras Baug, and other famous Pune attractions." },
    { question: "Are all Shaniwar Wada tour taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable sightseeing travel." },
    { question: "Can I book Pune to Shaniwar Wada Tour cab service online?", answer: "Yes, customers can easily book Pune to Shaniwar Wada Tour cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group sightseeing tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group sightseeing travel." },
    { question: "Are Pune to Shaniwar Wada Tour cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Shaniwar Wada Tour cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and tourist seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Kulkarni",
    feedback:
      "Enjoyed a smooth Pune to Shaniwar Wada tour cab experience with a comfortable ride and a knowledgeable driver who helped make the heritage visit easy and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "The Pune to Shaniwar Wada cab service was very convenient with punctual pickup, clean vehicle, and a relaxed travel experience for our sightseeing trip.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Shaniwar Wada Tour Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-shaniwar-wada-tour-cab.jpg",
  "description": "Book Pune Shaniwar Wada Tour Cab Service for comfortable heritage and city sightseeing. Shivai Travels offers guided local tours covering Shaniwar Wada and nearby Pune historical monuments with sedan, SUV, Innova, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-shaniwar-wada-tour-cab"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune Shaniwar Wada Tour Cab | Heritage Sightseeing Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Shaniwar Wada Tour Cab Service for heritage sightseeing and city tours. Affordable packages with sedan, SUV, Innova, and luxury cabs available 24x7 for Pune historical monuments and cultural travel."
  />

  <meta
    name="keywords"
    content="pune shaniwar wada tour cab, pune city heritage cab, shaniwar wada sightseeing taxi, pune historical tour cab, pune fort tour shaniwar wada cab, pune local sightseeing taxi, best pune tour cab shaniwar wada, cheap pune sightseeing cab, suv pune heritage tour cab, innova pune city tour cab, sedan pune tour taxi, pune guided tour cab, pune monument tour taxi, pune cultural tour cab, pune historical travel cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshaniwarwadatourcab;